import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../api/supabase';

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    const channel = supabase.channel('heartbeat');
    channel.subscribe((status) => {
      setConnected(status === 'SUBSCRIBED');
    });
    return () => { supabase.removeChannel(channel); };
  }, []);

  return (
    <SocketContext.Provider value={{ connected }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
export const useSocketEvent = () => {};
